/**
 * Static-translations for ru. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const ru = {
  'anon.description_default': 'Настраиваем гостевую сессию…',
  'anon.heading_default': 'Продолжить как гость',
  'anon.try_again': 'Попробовать снова',
  'auth.back_to_login': 'Назад ко входу',
  'auth.check_email_message': 'Проверьте почту — мы отправили код подтверждения.',
  'auth.check_email_title': 'Проверьте почту',
  'auth.confirm_email_subtitle': 'Введите код, который мы отправили на вашу почту, чтобы завершить регистрацию.',
  'auth.confirm_email_title': 'Подтвердите почту',
  'auth.confirmation_code': 'Код подтверждения',
  'auth.continue_with_apple': 'Продолжить через Apple',
  'auth.continue_with_facebook': 'Продолжить через Facebook',
  'auth.continue_with_github': 'Продолжить через GitHub',
  'auth.continue_with_google': 'Продолжить через Google',
  'auth.create_account': 'Создать аккаунт',
  'auth.default_subtitle': 'Войдите для доступа ко всем функциям и синхронизации данных.',
  'auth.email': 'Электронная почта',
  'auth.email_already_registered': 'Этот email уже зарегистрирован. Войдите ниже — паролем или аккаунтом, через который регистрировались.',
  'auth.email_exists': 'Аккаунт с таким email уже существует.',
  'auth.email_not_confirmed': 'Сначала подтвердите email.',
  'auth.forgot_password': 'Забыли пароль?',
  'auth.forgot_password_title': 'Забыли пароль?',
  'auth.forgot_subtitle': 'Введите email, мы отправим ссылку для сброса пароля.',
  'auth.generic_error': 'Что-то пошло не так',
  'auth.have_account': 'Уже есть аккаунт?',
  'auth.hide_password': 'Скрыть пароль',
  'auth.identity_already_linked': 'Этот аккаунт уже зарегистрирован. Войдите в него ниже.',
  'auth.invalid_credentials': 'Неверный email или пароль',
  'auth.invalid_otp': 'Код недействителен или истёк.',
  'auth.last_used': 'Последний вход · {email}',
  'auth.last_used_no_email': 'Последний вход',
  'auth.link_purchase_subheading': 'Привяжем покупку к аккаунту, чтобы доступ сохранился.',
  'auth.log_in': 'Войти',
  'auth.log_in_link': 'Войти',
  'auth.login_continue_purchase': 'Войдите, чтобы продолжить покупку',
  'auth.network_error': 'Ошибка сети. Проверьте подключение и попробуйте снова.',
  'auth.no_account': 'Нет аккаунта?',
  'auth.or': 'или',
  'auth.password': 'Пароль',
  'auth.passwords_mismatch': 'Пароли не совпадают',
  'auth.rate_limited': 'Слишком много запросов. Попробуйте позже.',
  'auth.repeat_password': 'Повторите пароль',
  'auth.reset_link_valid': 'Ссылка действует 1 час.',
  'auth.reset_password_subtitle': 'Введите код из письма и новый пароль.',
  'auth.reset_password_title': 'Сброс пароля',
  'auth.reset_sent_message': 'Если такой email существует, код для сброса отправлен.',
  'auth.reset_sent_subtitle': 'Мы отправили ссылку для сброса пароля. Следуйте инструкциям в письме.',
  'auth.restore_purchases_heading': 'Восстановить покупки',
  'auth.restore_purchases_subheading': 'Войдите, чтобы восстановить покупки.',
  'auth.send_reset': 'Отправить письмо для сброса',
  'auth.service_unavailable': 'Сервис временно недоступен. Попробуйте позже.',
  'auth.show_password': 'Показать пароль',
  'auth.sign_out': 'Выйти',
  'auth.sign_up': 'Зарегистрироваться',
  'auth.sign_up_link': 'Зарегистрироваться',
  'auth.signed_in': 'Вы вошли',
  'auth.signin_failed': 'Вход не удался',
  'auth.signup_failed': 'Регистрация не удалась',
  'auth.verify': 'Подтвердить',
  'auth.weak_password': 'Слишком слабый пароль.',
  'auth.welcome': 'Добро пожаловать!',
  'auth.welcome_signup': 'Добро пожаловать!',
  'countdown.d': 'д',
  'countdown.h': 'ч',
  'countdown.m': 'мин',
  'countdown.s': 'с',
  'cta.close': 'Закрыть',
  'cta.continue': 'Продолжить',
  'cta.get_lifetime_access': 'Купить навсегда',
  'cta.get_plan_daily': 'Купить дневной тариф',
  'cta.get_plan_generic': 'Купить {interval} тариф',
  'cta.get_plan_monthly': 'Купить месячный тариф',
  'cta.get_plan_weekly': 'Купить недельный тариф',
  'cta.get_plan_yearly': 'Купить годовой тариф',
  'cta.start_trial': 'Начать {days}-дневный пробный период',
  'modal.close_aria': 'Закрыть',
  'modal.continue': 'Продолжить',
  'modal.error_generic': 'Что-то пошло не так',
  'modal.loading': 'Загрузка…',
  'modal.purchase_restored_subtitle': 'Всё готово — пользуйтесь!',
  'modal.purchase_restored_title': 'С возвращением',
  'modal.purchase_success_subtitle': 'Всё готово — пользуйтесь!',
  'modal.purchase_success_title': 'Платёж получен',
  'modal.verifying_subscription': 'Проверяем подписку…',
  'nav.back': '← Назад',
  'nav.back_aria': 'Назад',
  'offer.limited_time': 'Ограниченное предложение',
  'payment.awaiting_subtitle': 'Мы определим оплату автоматически — или нажмите кнопку, когда закончите.',
  'payment.awaiting_title': 'Ожидание оплаты...',
  'payment.checking': 'Проверяем…',
  'payment.ive_paid': 'Я оплатил',
  'payment.open_checkout_again': 'Открыть оплату снова',
  'payment.open_checkout_button': 'Открыть оплату',
  'payment.popup_blocked_message': 'Браузер заблокировал вкладку с оплатой. Нажмите ниже, чтобы открыть её.',
  'payment.popup_blocked_title': 'Разрешите всплывающие окна, чтобы продолжить',
  'payment.popup_help_text': 'Окно оплаты не открылось или заблокировано? Нажмите здесь, чтобы открыть снова.',
  'payment.still_processing': 'Платёж ещё обрабатывается. Попробуйте ещё раз через мгновение.',
  'payment.tab_closed_retry': 'Закрыли вкладку? Попробуйте снова',
  'pricing.free_trial_days': '{days}-дневная бесплатная пробная версия',
  'pricing.included_per': 'Включено за {interval}:',
  'pricing.interval.day': 'день',
  'pricing.interval.lifetime_short': 'навсегда',
  'pricing.interval.month': 'месяц',
  'pricing.interval.period': 'период',
  'pricing.interval.week': 'неделя',
  'pricing.interval.year': 'год',
  'pricing.money_back': '30-дневная гарантия возврата денег',
  'pricing.most_popular': 'Самый популярный',
  'pricing.no_prices': 'Тарифов нет.',
  'pricing.plan_label.daily': 'ЕЖЕДНЕВНЫЙ ТАРИФ',
  'pricing.plan_label.lifetime': 'навсегда',
  'pricing.plan_label.monthly': 'ежемесячный тариф',
  'pricing.plan_label.weekly': 'еженедельный тариф',
  'pricing.plan_label.yearly': 'ежегодный тариф',
  'pricing.plans_aria': 'Тарифы',
  'session.contact_support': 'Поддержка',
  'session.restore_purchases': 'Восстановить покупки',
  'session.sign_out': 'Выйти',
  'session.signed_in_as_prefix': 'Вы вошли как',
  'session.signing_out': 'Выход…',
  'support.attachments_aria': 'Загрузка вложений',
  'support.attachments_label': 'Вложения',
  'support.close_button': 'Закрыть',
  'support.done_button': 'Готово',
  'support.dropzone_text': 'Перетащите изображения сюда или кликните для выбора',
  'support.email_placeholder': 'Введите email',
  'support.file_requirements': 'JPEG/PNG/WebP, до {max} файлов, ≤ {size} МБ каждый',
  'support.heading': 'Поддержка',
  'support.instruction': 'Заполните форму ниже для отправки запроса в поддержку.',
  'support.invalid_email': 'Некорректный email',
  'support.invalid_file': 'Только JPEG/PNG/WebP, ≤ {size} МБ каждый',
  'support.message_length': '1–5000 символов',
  'support.message_placeholder': 'Введите сообщение',
  'support.remove_file_aria': 'Удалить {filename}',
  'support.required': 'Обязательно',
  'support.send_another': 'Отправить ещё запрос',
  'support.send_button': 'Отправить',
  'support.sending': 'Отправка…',
  'support.sending_as': 'Отправка от',
  'support.subject_length': '3–200 символов',
  'support.subject_placeholder': 'Введите тему',
  'support.success_heading': 'Запрос отправлен',
  'support.success_message_prefix': 'Мы получили ваше сообщение и ответим на',
  'support.too_many_files': 'До {max} файлов'
} as const;

export default ru;
